import React, { useState } from 'react';
import { Container, Row, Card, Col, Form as BSForm } from 'react-bootstrap';
import Loader from 'react-spinner-loader';
import { CandidatesTable } from '../../admin-candidate/candidate-listing-table/candidatesTables';
import { CandidateService } from '../../../../services/candidateService';
import { prepareCandidateData } from '../../../../utils/dataTableUtilsAdmin';
import SigniteButton from '../../../ui-elements/signite-button/signiteButton';

const AssignedCandidates = () => {
    const [loader, setLoader] = useState(true);
    const [candidatesLoading, setCandidatesLoading] = useState(true);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [updatedFirstName, setUpdatedFirstName] = useState('');
    const [updatedLastName, setUpdatedLastName] = useState('');
    const [candidateTableData, setCandidateTableData] = useState({ columns: [], data: [] });

    const fetchData = async ({ pageIndex = 0, pageSize = 10 }) => {
        setCandidatesLoading(true);
        try {
            const retData = await CandidateService.getAllCandidates(
                pageIndex,
                pageSize,
                updatedFirstName,
                updatedLastName,
                '',
                true
            );

            const tableData = prepareCandidateData({ candidates: retData.data.candidates || [] });
            setCandidateTableData(tableData);
            setCandidatesLoading(false);
            setLoader(false);

            return {
                rows: {
                    data: tableData.data,
                    columns: tableData.columns,
                },
                pageCount: retData?.data?.pageCount ?? 1,
            };
        } catch (error) {
            console.error("Error fetching assigned candidates:", error);
            setCandidatesLoading(false);
            setLoader(false);
            return {
                rows: { data: [], columns: [] },
                pageCount: 0,
            };
        }
    };

    const setSearchField = (event) => {
        switch (event.target.id) {
            case 'firstName':
                setFirstName(event.target.value);
                if (event.target.value === "" && lastName === "") {
                    triggerCandidateSearch("", "");
                }
                break;
            case 'lastName':
                setLastName(event.target.value);
                if (event.target.value === "" && firstName === "") {
                    triggerCandidateSearch("", "");
                }
                break;
        }
    };


    const triggerCandidateSearch = (fname, lname) => {
        setLoader(true);
        setUpdatedFirstName(fname);
        setUpdatedLastName(lname);
        fetchData({ pageIndex: 0, pageSize: 10 });
    };

    return (
        <Container fluid>
            <Loader show={loader} type="body" stack="vertical" message="Loading Data" />
            <Row>
                <Card className="p-0">
                    <Card.Header style={{ backgroundColor: 'white' }}>
                        <BSForm className="pr w-100 m-0">
                            <Row className="align-items-center">
                                <Col lg={5}></Col>

                                <Col xs="auto">
                                    <BSForm.Control
                                        className="mb-2"
                                        id="firstName"
                                        placeholder="First Name"
                                        value={firstName}
                                        onChange={(e) => setSearchField(e)}
                                        spellCheck='false'
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                triggerCandidateSearch(firstName, lastName);
                                            }
                                        }}
                                    />
                                </Col>
                                <Col xs="auto">
                                    <BSForm.Control
                                        className="mb-2"
                                        id="lastName"
                                        placeholder="Last Name"
                                        value={lastName}
                                        onChange={(e) => setSearchField(e)}
                                        spellCheck='false'
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                triggerCandidateSearch(firstName, lastName);
                                            }
                                        }}
                                    />
                                </Col>
                                <Col xs="auto">
                                    <SigniteButton
                                        variant={'primary'}
                                        className="mb-2 ms-2"
                                        onClick={() => triggerCandidateSearch(firstName, lastName)}
                                    >
                                        Search
                                    </SigniteButton>
                                </Col>
                            </Row>
                        </BSForm>
                    </Card.Header>
                    <Card.Body style={{ backgroundColor: 'white' }}>
                        {console.log("CandidateTableData props:", candidateTableData)}

                        <CandidatesTable
                            columns={candidateTableData.columns}
                            fetchData={fetchData}
                            firstName={updatedFirstName}
                            lastName={updatedLastName}
                        />
                    </Card.Body>
                </Card>
            </Row>
        </Container>
    );
};

export default AssignedCandidates;